export const MAX_PHOTOS_PER_POST = 10;
export const MAX_CAPTION_LENGTH = 2000;
